export const LandingPageSetupDetailsData = [
    {
        title: 'Create Landing Page',
        content: 'Create and customize landing pages for your community.',
    },
    {
        title: 'Publish Your Landing Page',
        content: 'Publish a landing page to make it accessible to the public and shareable with your community.',
    },
];
